export const STEP = {
  SEND_CALL_REQUEST: 'SEND_CALL_REQUEST',
  GOT_CALL_REQUEST: 'GOT_CALL_REQUEST',
  OFFER_SENT: 'OFFER_SENT',
  OFFER_RECEIVED: 'OFFER_RECEIVED',
  ANSWER_SENT: 'ANSWER_SENT',
  ANSWER_RECEIVED: 'ANSWER_RECEIVED',
  UNMUTING_MEDIA_TRACKS: 'UNMUTING_MEDIA_TRACKS',
  GOT_LOCAL_STREAM_TRACKS: 'GOT_LOCAL_STREAM_TRACKS',
  GOT_REMOTE_STREAM_AND_TRACK: 'GOT_REMOTE_STREAM_AND_TRACK',
  ICE_CONNECTION_STATE_CHANGE: 'ICE_CONNECTION_STATE_CHANGE',
  GET_USER_MEDIA_ERROR: 'GET_USER_MEDIA_ERROR',
  MULTIPLE_OFFERS_ERROR: 'MULTIPLE_OFFERS_ERROR',
  ICE_CANDIDATE_RECEIVED: 'ICE_CANDIDATE_RECEIVED',
  MAX_TIMEOUT_EXCEEDED: 'MAX_TIMEOUT_EXCEEDED',
  ANSWER_ACK_SENT: 'ANSWER_ACK_SENT',
  CREATE_OFFER_ERROR: 'CREATE_OFFER_ERROR',
  CREATE_ANSWER_ERROR: 'CREATE_ANSWER_ERROR',
  RETRY: 'RETRY',
  SET_REMOTE_DESC_ERROR: 'SET_REMOTE_DESC_ERROR',
  SET_LOCAL_DESC_ERROR: 'SET_LOCAL_DESC_ERROR',
  ADD_ICE_CANDIDATE_ERROR: 'ADD_ICE_CANDIDATE_ERROR',
  OFFER_ANSWER_MISMATCH: 'OFFER_ANSWER_MISMATCH',
  CUE_CALL_CONNECTED: 'CUE_CALL_CONNECTED',
  END_CALL_BUTTON_PRESSED: 'END_CALL_BUTTON_PRESSED',
  END_TIMER_EXPIRED: 'END_TIMER_EXPIRED',
  END_CALL_BY_TEACHER: 'END_CALL_BY_TEACHER',
  UPLOADING_RECORDING: 'UPLOADING_RECORDING',
  MIME_TYPE_NOT_SUPPORTED_FOR_RECORD: 'MIME_TYPE_NOT_SUPPORTED_FOR_RECORD',
  MEDIA_RECORDER_ERROR: 'MEDIA_RECORDER_ERROR',
  RTC_PEER_STATS: 'RTC_PEER_STATS',
  CUE_CALL_IS_UNSTABLE: 'CUE_CALL_IS_UNSTABLE',
  ICE_CONNECTION_DISCONNECTED: 'ICE_CONNECTION_DISCONNECTED',
  ERROR_TIMEOUT: 'ERROR_TIMEOUT',
};

export const LOG_LEVELS = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
  FATAL: 'FATAL',
  OFF: 'OFF',
  TRACE: 'TRACE',
};

export const IN_HOUSE_AV_SENTRY_ISSUE_LIST = [
  "Failed to execute 'start' on 'MediaRecorder'",
  'Cannot get _mediaStoppedListener, NativeVideoElementWrapper is destroyed',
  'AbortError: The play() request was interrupted because the media was removed from the document. https://goo.gl/LdLk22',
  'Cannot get _domAudioOnlyVideoElement, NativeVideoElementWrapper is destroyed',
  'AbortError: The play() request was interrupted by a new load request. https://goo.gl/LdLk22',
];
// this sentry issue is coming when in-house media-recorder has some issue.

export const WEB_RTC_AV_SENTRY_ISSUE_LIST = ['RTCPeerConnection is not defined'];
